import { render } from "./DeleteDataRequest.vue?vue&type=template&id=ffd81c7c&scoped=true"
import script from "./DeleteDataRequest.vue?vue&type=script&lang=js"
export * from "./DeleteDataRequest.vue?vue&type=script&lang=js"

import "./DeleteDataRequest.vue?vue&type=style&index=0&id=ffd81c7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd81c7c"]])

export default __exports__